import { ApplyModes, BaseAPI } from 'lecom-api';

import { FormStore } from 'form/reflux/form_store';
import { FlashMessagesStore, FlashMessagesActions } from 'flash_message/reflux/flash_messages_store';
import FlashMessageStoreItem from 'flash_message/models/flash_messages_store_item.js';

import FlashMessagesTypes from 'flash_message/constants/flash_messages_types'

import { getClassProperties } from 'utils/object_utils';

var _defaultId;
var instances = { };

/**
* Classe FlashMessageAPI
* @class FlashMessageAPI
* @extends BaseAPI
*/
class FlashMessageAPI extends BaseAPI {

	/**
	* @param {*} param0
	*
	* @constructor
	*/
	constructor({ id, applyMode = FlashMessageAPI.applyMode }) {
		super({ id, applyMode, storeClass: FlashMessagesStore });

		FlashMessageAPI.flashMessageProperties().forEach((flashMessageProperty) => {
			this[flashMessageProperty] = this._propertyAccessor.bind(this, flashMessageProperty);
		});
	}

	/**
	*
	* @static
	*/
	static applyMode = ApplyModes.LAZY;

	/**
	*
	* @static
	* @param {*} id
	* @param {*} applyMode
	*/
	static flash(id, applyMode = FlashMessageAPI.applyMode) {
		if(!id) id = FlashMessageAPI.getDefaultId();
		if (!instances[id]) {
			instances[id] = new FlashMessageAPI({id, applyMode});
		}
		return instances[id];
	}

	/**
	* @static
	* @param {*} id
	*/
	static setDefault(id) {
		const flashStore = Object.keys(FlashMessagesStore.store).filter(store => store.id === id);
		if (!flashStore) throw new Error(`Flash Messages Store not found for id: ${id}`);
		_defaultId = id;
	}

	/**
	* @static
	*/
	static getDefaultId() {
		const { store } = FormStore;
		return _defaultId || store[Object.keys(store)[0]].id;
	}

	static flashMessageProperties() {
		return getClassProperties(FlashMessageStoreItem)
		.filter((p) => ['id', 'messages'].indexOf(p) === -1);
	}

	/**
	*
	* @param {*} messageIndex
	*/
	messages(messageIndex) {
		var messages = this.storeClass.store[this._id].messages;
		if (typeof messageIndex !== 'undefined') messages = this._getMessageByIndex(messageIndex);
		return messages;
	}

	/**
	*
	* @param {*} message
	*/
	addMessage(message) {
		this.storeClass.listenables.addMessage(this._id, message);
		return this._isInEagerMode() ? this._buildEventPromise(this.storeClass.events.MESSAGE_ADDED) : this;
	}

	addMessageIfNotExists(message) {
		let added = this.storeClass.listenables.addMessageIfNotExists(this._id, message);
		return (added && this._isInEagerMode()) ? this._buildEventPromise(this.storeClass.events.MESSAGE_ADDED) : this;
	}

	/**
	*
	* @param {*} messageIndex
	*/
	removeMessage(messageIndex) {
		var message = this._getMessageByIndex(messageIndex);
		this.storeClass.listenables.removeMessage(this._id, message.id);
		return this._isInEagerMode() ? this._buildEventPromise(this.storeClass.events.MESSAGE_REMOVED) : this;
	}

	removeMessageByContent(messageContent) {
		let messageFound = false;
		if (typeof messageContent !== 'undefined') {			
			const messages = this.storeClass.store[this._id] ? this.storeClass.store[this._id].messages : [];
			for (const item of messages) {
				if (item.message === messageContent) {
					messageFound = true;
					this.storeClass.listenables.removeMessage(this._id, item.id);
				}
			}
		}
		return (messageFound && this._isInEagerMode()) ? this._buildEventPromise(this.storeClass.events.MESSAGE_REMOVED) : this;
	}

	clear() {
		this.storeClass.listenables.clear(this._id);
		return this._isInEagerMode() ? this._buildEventPromise(this.storeClass.events.MESSAGE_REMOVED) : this;
	}

	_getMessageByIndex(messageIndex) {
		let messages = this.storeClass.store[this._id].messages;
		if (typeof messageIndex === 'undefined' || messageIndex + 1 > messages.length)
			throw new Error("Index not found in messages");
		return messages[messageIndex];
	}

}

export default FlashMessageAPI;
